import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  LayoutDashboard,
  Diamond,
  Layers,
  Store,
  Users,
  Bell,
  Home as HomeIcon,
  Sparkles,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import DashboardTab from "./admin/DashboardTab";
import DesignsTab from "./admin/DesignsTab";
import SubCategoriesTab from "./admin/SubCategoriesTab";
import StoreTab from "./admin/StoreTab";
import CustomersTab from "./admin/CustomersTab";
import EventsTab from "./admin/EventsTab";
import HomepageTab from "./admin/HomepageTab";
import LimitedCollectionsTab from "./admin/LimitedCollectionsTab";

const TABS = [
  { key: "dashboard", label: "Dashboard", Icon: LayoutDashboard, Component: DashboardTab },
  { key: "home", label: "Homepage", Icon: HomeIcon, Component: HomepageTab },
  { key: "limited", label: "Limited Collections", Icon: Sparkles, Component: LimitedCollectionsTab },
  { key: "designs", label: "Designs", Icon: Diamond, Component: DesignsTab },
  { key: "subcats", label: "Sub-categories", Icon: Layers, Component: SubCategoriesTab },
  { key: "store", label: "Store Info", Icon: Store, Component: StoreTab },
  { key: "customers", label: "Customers", Icon: Users, Component: CustomersTab },
  { key: "events", label: "Enquiry Log", Icon: Bell, Component: EventsTab },
];

/**
 * Admin Panel shell — only guards the route (redirects non-admins),
 * renders the sidebar navigation, and dispatches to the currently
 * active tab component. All tab logic lives under /pages/admin/.
 */
export default function AdminPage() {
  const { user, isAdmin, loading } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("dashboard");

  useEffect(() => {
    if (!loading && !isAdmin) navigate("/", { replace: true });
  }, [isAdmin, loading, navigate]);

  if (loading) {
    return (
      <div className="boot-screen">
        <div className="boot-logo">
          <span className="name">Alankar · Admin</span>
        </div>
        <div className="boot-shimmer" />
      </div>
    );
  }

  if (!isAdmin) return null;

  const ActiveTab = TABS.find((t) => t.key === tab)?.Component || DashboardTab;

  return (
    <div className="admin-shell alankar-site">
      <aside className="admin-side">
        <div className="admin-brand">
          <span className="name">Alankar Admin</span>
          <span className="sub">SIGNED IN AS {user && user.name}</span>
        </div>
        <nav className="admin-nav">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              className={tab === t.key ? "on" : ""}
              onClick={() => setTab(t.key)}
              data-testid={`admin-tab-${t.key}`}
            >
              <t.Icon size={16} /> {t.label}
            </button>
          ))}
        </nav>
        <Link to="/" className="admin-back">
          <ArrowLeft size={14} /> Back to website
        </Link>
      </aside>

      <main className="admin-main">
        <ActiveTab />
      </main>
    </div>
  );
}
